import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { ProjectService } from '../../../services/project.service';
import { UserService } from '../../../services/core.user.service';

import * as _ from 'lodash';

@Component({
    selector: 'project-builds',
    template: require('./project.builds.component.html')
})
export class ProjectBuildsComponent implements OnInit {

    @Input() builds: any = null;

    protected buildFailureCount = 0;
    protected buildSuccessCount = 0;

    constructor(
        private projectService: ProjectService,
        private stateService: StateService, 
        private userService: UserService,
    ) { }
    
    ngOnInit() {
        this.buildFailureCount = 0;

        if (this.builds) {
            this.setBuildData();
        } else {
            this.projectService.builds(this.stateService.params.unixName)
            .then((response) => {
                this.builds = _.get(response, 'items', []);
            })
            .catch((error) => {
                if (! this.userService.session.hasUser()) {
                    this.builds = [];
                }
            }).finally(() => this.setBuildData());
        }
    }

    setBuildData() {
        this.builds = _.sortBy(this.builds, '-id');
        this.buildFailureCount = _.filter(
            this.builds,
            { wasSuccessful: true }
        ).length;
        this.buildSuccessCount = this.builds.length - this.buildFailureCount;
    }
}